exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".error{color:red}.back-to-car-icon{top:105px}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/contact.vue"],"names":[],"mappings":"AACA,OACE,SAAW,CACZ,AACD,kBACE,SAAW,CACZ","file":"contact.vue","sourcesContent":["\n.error {\n  color: red;\n}\n.back-to-car-icon {\n  top: 105px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74b88aba","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboards/car/mainCar/contact.vue
// module id = 905
// module chunks = 6